<div
  class="card-layer collapse-card-layer"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
  [class.editable]="contentEditable()"
  [class.disabled]="editObject() && editObject() !== location()"
>
  @if (location() && !location()!.delete && !location()!.NextLayerIsEquipment) {
    <nz-collapse>
      @for (child of location()!.children; track child?.objectID ?? $index) {
        @if (!child?.delete) {
          <nz-collapse-panel
            [nzHeader]="headerTpl"
            [nzActive]="!isMobile()"
            [nzDisabled]="
              (child.children.length === 0 &&
                !child.NextLayerIsEquipment &&
                !contentEditable()) ||
              (child.children.length === 0 &&
                !child.NextLayerIsEquipment &&
                disableCollapseBasedOnSiblings(child) &&
                contentEditable()) ||
              editedObjectId() !== 0 ||
              (contentEditable() &&
                child.children.length === 0 &&
                disableCollapseBasedOnSiblings(child))
            "
            [nzExpandedIcon]="
              (child.children.length === 0 &&
                !child.NextLayerIsEquipment &&
                !contentEditable()) ||
              editedObjectId() !== 0
                ? 'icons:circle'
                : 'icons:caret-right'
            "
          >
            <div class="hierarchy-line"></div>

            <app-collapse-card-layer
              [location]="child"
              [contentEditable]="contentEditable()"
              (add)="onAdd($event)"
              (editCompleted)="OnEditComplete()"
              (addEquipment)="onAddEquipment($event)"
            >
            </app-collapse-card-layer>

            <ng-template #headerTpl>
              <app-rename-card-header
                (editCompleted)="OnEditComplete()"
                [location]="child"
                [parentArray]="location()!.children"
                [innerWrapper]="true"
                [isEditable]="contentEditable()"
                (delete)="onDelete($event)"
                (nameError)="onNameError($event)"
              ></app-rename-card-header>
            </ng-template>
          </nz-collapse-panel>
        }
      }
    </nz-collapse>

    @if (contentEditable()) {
      <app-nav-button
        [svgIcon]="'icons:pluscircle'"
        (clickEvent)="onAdd(location()!)"
        [lighttertiary]="true"
        [disabled]="editedObjectId() !== 0"
        [bodyBold]="true"
        class="add-eq-btn"
        [class.add-eq-btn-wide]="isDesktop()"
        [class.noElementsAbove]="(location()?.children?.length ?? 0) === 0"
        [class.editableLastLayer]="needsAdditionalPadding()"
      >
        {{
          location()!.nextLayer !== "e"
            ? i18n.langString("add_layer_" + location()!.nextLayer)
            : i18n.langString("add_layer_floor")
        }}
      </app-nav-button>
    }
  }

  @if (location() && !location()!.delete && location()!.NextLayerIsEquipment) {
    @for (child of location()!.children; track child?.objectID ?? $index) {
      <app-asset-nav-button
        [asset]="child"
        [working]="true"
        [svg_icon]="getIconByEquipmentType(child)"
        [blackBorder]="true"
        [blackCoral]="true"
        [greyOut]="contentEditable()"
        [amount]="child.sensors ? child.sensors.length : 0"
      >
        {{ child.objectName | nameSlice }}
      </app-asset-nav-button>
    }

    @if (!contentEditable()) {
      <app-nav-button
        [svgIcon]="'icons:pluscircle'"
        (clickEvent)="onAddEquipment(location()!)"
        class="add-eq-btn"
        [primary]="!contentEditable()"
        [lighttertiary]="contentEditable()"
        [disabled]="editedObjectId() !== 0"
        [bodyBold]="true"
      >
        {{ i18n.langString("add_layer_h") }}
      </app-nav-button>
    }
  }
</div>
